import { useState, useEffect, useCallback } from 'react';
import { SftpConnectionsApi } from '../clients/sftp-connections/sftp-connections.api';

export const useGetSftpConnection = (
  organizationId,
  connectionId,
  options = {},
) => {
  const { enabled = true } = options;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchConnection = useCallback(async () => {
    if (!organizationId || !connectionId) return;
    setLoading(true);
    setError(null);
    try {
      const response = await SftpConnectionsApi.getSftpConnection(
        organizationId,
        connectionId,
      );
      setData(response.data.data);
    } catch (err) {
      setError(
        err.response?.data?.message || 'Failed to fetch SFTP connection',
      );
    } finally {
      setLoading(false);
    }
  }, [organizationId, connectionId]);

  useEffect(() => {
    if (!enabled) return;
    fetchConnection();
  }, [fetchConnection, enabled]);

  return {
    data,
    loading,
    error,
    refetch: fetchConnection,
    refresh: fetchConnection,
  };
};
